import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";
import { defaultChildRoute } from "../legacy-redirects";

export const chargebackSettingsRoutes: PermissionedRouteObject[] = [
  {
    path: "chargebacks",
    handle: {
      permission: settingsPagePermission("chargebacks/chargebacks"),
      get breadcrumb() {
        return t("Chargebacks");
      },
    },
    children: [
      defaultChildRoute("reclaim"),
      {
        path: ":tab",
        lazy: async () => {
          const { ChargebacksSettingsPage } =
            await import("../../../../setting/chargebacks/chargebacks-settings-page");
          return { Component: ChargebacksSettingsPage };
        },
      },
    ],
  },
];
